'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElapsedTimer = exports.datetimeStringType = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _HoursMinsSeconds = require('./HoursMinsSeconds');

var _HoursMinsSeconds2 = _interopRequireDefault(_HoursMinsSeconds);

var _ElapsedTimer = require('./ElapsedTimer.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var datetimeStringType = exports.datetimeStringType = function datetimeStringType(props, propName, componentName) {
  var dateTimeProp = props[propName];

  if (dateTimeProp && (typeof dateTimeProp !== 'string' || isNaN(Date.parse(dateTimeProp)))) {
    // eslint-disable-line
    return new Error(propName + ' in ' + componentName + ' is an invalid datetime string');
  }
};

/**
 * Component to show running or or total elapsed time.
 * Please do not confuse this with a conventional timer. It will only count up
 * displaying the difference between the startTime and the currentTime. There
 * is no notion of pausing it.
 */
var ElapsedTimer = exports.ElapsedTimer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ElapsedTimer, _Component);

  function ElapsedTimer(props) {
    (0, _classCallCheck3.default)(this, ElapsedTimer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ElapsedTimer.__proto__ || (0, _getPrototypeOf2.default)(ElapsedTimer)).call(this, props));

    _this.getElapsedTime = function () {
      var _this$props = _this.props,
          startTime = _this$props.startTime,
          stopTime = _this$props.stopTime;
      var intervalTime = _this.state.intervalTime;

      var startMsecs = new Date(startTime).getTime();
      var stopMsecs = new Date(stopTime).getTime();

      // Do we have a specified duration?
      if (startTime && stopTime) {
        return Math.max(0, stopMsecs - startMsecs);
      }

      // Do we have a startTime and intervalTime?
      if (startTime && intervalTime) {
        return Math.max(0, intervalTime - startMsecs);
      }

      // Return 0 otherwise
      return 0;
    };

    _this.needToStartInterval = function () {
      var _this$props2 = _this.props,
          startTime = _this$props2.startTime,
          stopTime = _this$props2.stopTime;
      var interval = _this.state.interval;


      return startTime && !stopTime && !interval;
    };

    _this.startInterval = function () {
      var intervalLength = _this.props.intervalLength;

      var interval = setInterval(_this.intervalUpdate, intervalLength);

      _this.setState({ interval: interval });
    };

    _this.intervalUpdate = function () {
      _this.setState({
        intervalTime: new Date().getTime()
      });
    };

    _this.stopInterval = function () {
      var interval = _this.state.interval;


      clearInterval(interval);
    };

    _this.state = {
      interval: null,
      intervalTime: new Date().getTime()
    };
    return _this;
  }

  /**
   * Start interval if necessary
   */


  (0, _createClass3.default)(ElapsedTimer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Do we need to start an interval?
      var _props = this.props,
          startTime = _props.startTime,
          stopTime = _props.stopTime;


      if (startTime && !stopTime) {
        this.startInterval();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var startTime = nextProps.startTime,
          stopTime = nextProps.stopTime;
      var interval = this.state.interval;

      // Do we need to start the interval?

      if (startTime && !stopTime && !interval) {
        this.startInterval();
      }

      // Do we need to stop the interval?
      if (startTime && stopTime || !startTime) {
        this.stopInterval();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Always remove interval
      this.stopInterval();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          startTime = _props2.startTime,
          stopTime = _props2.stopTime,
          TimeComponent = _props2.timeComponent;


      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(TimeComponent, {
          duration: this.getElapsedTime(),
          running: startTime && !stopTime
        })
      );
    }
  }]);
  return ElapsedTimer;
}(_react.Component), _class.propTypes = {
  /**
   * Used by glamorous for styles
   */
  className: _propTypes2.default.string,
  /**
   * Component function to render time.
   * Will receive `duration` prop which will be the elapsed time in msecs,
   * and a `running` signifying that the timer is actively running.
   * Defaults to HoursMinsSeconds component.
   */
  timeComponent: _propTypes2.default.func,
  /**
   * Length of interval between clock ticks in msecs
   */
  intervalLength: _propTypes2.default.number,
  /**
   * Date parseable string representing the datetime to start from.
   */
  startTime: datetimeStringType,
  /**
   * Date parseable string representing the datetime the elapsed
   * timer stopped at.
   */
  stopTime: datetimeStringType
}, _class.defaultProps = {
  intervalLength: 1000,
  timeComponent: _HoursMinsSeconds2.default
}, _temp);
exports.default = (0, _glamorous2.default)(ElapsedTimer)(_ElapsedTimer.defaultStyle, _ElapsedTimer.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/ElapsedTimer/ElapsedTimer.js
// module id = 460
// module chunks = 0